import { FormControlLabel, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PerfectScrollbar from 'components/SafePerfectScrollbar';

const StyledGridRoot = styled(Grid)(() => ({
  margin: '-1rem',
}));

const StyledGridSection = styled(Grid)(() => ({
  height: 'calc(100vh - 15rem)',
  padding: '1rem',
}));

const StyledGridContainer = styled('div')(() => ({
  margin: '1rem auto',
  width: '40%',
}));

const StyledFormLabel = styled('legend')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.875rem',
  margin: theme.spacing(1, 0),
}));

const StyledGridContainerSubtitle = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontWeight: 'bold',
  fontSize: '1.125rem',
  letterSpacing: '-0.5px',
  lineHeight: '1.5rem',
  fontFamily: theme.typography.mainFont,
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    color: theme.palette.primary[500],
    fontWeight: 700,
  },
}));

const StyledPerfectScrollbar = styled(PerfectScrollbar)(() => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 1.5rem 2rem 0',
  padding: '0',
  maxHeight: 'calc(35vh - 3.5rem)',
}));

const StyledScrollbarContainer = styled(Grid)(() => ({}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary[500],
  fontWeight: 700,
}));

const StyledGridSectionBorderLeft = styled(Grid)(({ theme }) => ({
  height: 'calc(100vh - 15rem)',
  padding: '1rem',
  borderLeft: `3px solid ${theme.palette.grey[200]}`,
}));

export {
  StyledFormControlLabel, StyledFormLabel, StyledGridContainer, StyledGridContainerSubtitle, StyledGridRoot,
  StyledGridSection, StyledGridSectionBorderLeft, StyledPerfectScrollbar, StyledScrollbarContainer, StyledTypography
};

